<template>
  <div class="error-page">
    <div class="pc justify-center items-center flex-column">
      <img class="error-img" src="../assets/images/pc-404.png" alt="404" />
      <span class="error-text">Sorry！ 您的页面走丢了</span>
    </div>
    <div class="wrap">
      <div class="error-main flex-column justify-center items-center">
        <img class="error-img" src="../assets/images/wrap_imgs/wrap_404.png" alt="404" />
        <span class="error-text">Sorry！ 您的页面走丢了</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Error",
  created(){
      window.eventBus.$emit('onError',"v1002", {"message":"页面404"});//通知埋点请求
      setTimeout(() => {//5s 后跳到首页
        this.$router.push('/')
      }, 5000);
  }
};
</script>
<style lang="stylus" scoped>
@media screen and (min-width: 755px) {
  .pc {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #ffffff;
  }

  .wrap {
    display: none;
  }
}

@media screen and (max-width: 755px) {
  .pc {
    display: none;
  }

  .wrap {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #ffffff;
  }
}

.error-page {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .wrap {
    padding: 0 52px;

    .error-main {
      width: 270px;

      .error-img {
        width: 100%;
        height: 183px;
        margin: 94px 0 31px;
      }

      .error-text {
        height: 22px;
        font-size: 16px;
        color: #636880;
        line-height: 22px;
      }
    }
  }

  .pc {
    .error-img {
      width: 721px;
      height: 421px;
      margin: 170px 0 55px;
    }

    .error-text {
      display: block;
      font-size: 20px;
      color: #636880;
      line-height: 28px;
    }
  }
}
</style>